import React, {Component} from 'react'
import classNames from 'classnames'
import ArticlesCarousel from '../ArticlesCarousel'
import logger from 'logger'

class ArticlesCarouselPreview extends Component {
  render () {
    const {articles, className} = this.props
    if (!articles || articles.length === 0) {
      logger.warn('No articles provided, so the articles carousel is being hidden.')
      return null
    }
    return (
      <div className={classNames([
        'ArticlesCarouselPreview',
        className
      ])}>
        {/* <header className='ArticlesCarouselPreview__header' aria-label='Must Reads'>
          <h3 className='ArticlesCarouselPreview__header__title'>Must Reads</h3>
        </header> */}
        <ArticlesCarousel articles={articles} className='ArticlesCarouselPreview__carousel' />
      </div>
    )
  }
}

ArticlesCarouselPreview.defaultProps = {
  articles: [],
  className: ''
}

export default ArticlesCarouselPreview



// WEBPACK FOOTER //
// ./client/components/ArticlesCarouselPreview/ArticlesCarouselPreview.js